import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga de los 6 tomos + 3 bonus en formato PDF. Podés leerlo desde el celular, tablet o PC.'
}, {
  q: '¿Funciona si ya tomé muchos antibióticos?',
  a: 'Sí, de hecho es cuando más lo necesitás. Los antibióticos arrasan la flora protectora y dejan terreno libre para la Cándida. La Fase 2 del protocolo está diseñada específicamente para reconstruir esa flora.'
}, {
  q: '¿Cuánto tarda en verse el resultado?',
  a: 'La mayoría reporta alivio de síntomas agudos en las primeras 72 horas (Fase de Choque). El protocolo completo de 21 días está diseñado para la erradicación duradera.'
}, {
  q: '¿Necesito comprar suplementos caros?',
  a: 'No. El Tomo 3 está basado 100% en supermercados argentinos (Coto, Carrefour, Jumbo) y dietéticas locales. Hay opciones para todos los presupuestos.'
}, {
  q: '¿Esto reemplaza al ginecólogo?',
  a: 'No. Es un protocolo complementario de biología funcional. Ante síntomas graves siempre consultá a un profesional.'
}, {
  q: '¿Puedo hacerlo si estoy menstruando?',
  a: 'Sí. De hecho el período es el momento de mayor vulnerabilidad. El Tomo 2 tiene un apartado específico para adaptar el protocolo durante la menstruación.'
}, {
  q: '¿Y si la cándida me vuelve igual?',
  a: 'El Tomo 6 (Blindaje y Recidivas) y el Bonus 3 (Auditoría de Baño) están diseñados exactamente para eso: identificar y eliminar los factores de riesgo activos en tu entorno.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-81">
      <p className="text-brand-teal text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-82">
        Tus dudas resueltas
      </p>
      <h2 className="text-[24px] font-bold text-white mb-8 leading-tight" data-id="element-83">
        Preguntas frecuentes
      </h2>

      <div className="flex flex-col" data-id="element-84">
        {faqs.map((faq, i) => <div key={i} className="border-b border-white/[0.08]" data-id="element-85">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between py-5 text-left group" data-id="element-86">
              <span className="text-[15px] font-semibold text-white pr-4 group-hover:text-brand-teal transition-colors" data-id="element-87">
                ❓ {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-muted flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180 text-brand-teal' : ''}`} data-id="element-88" />
            </button>
            <AnimatePresence data-id="element-89">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-90">
                  <p className="text-[15px] text-brand-muted leading-relaxed pb-5 pl-6" data-id="element-91">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}